import React, { useEffect } from "react"
import gsap from 'gsap'

const AnimateCaption = ({text, titles,...props}) => {
  useEffect(() => {
     var tl = gsap.timeline({ repeat:-1, delay:2});
     tl.to('.animating--title .inner', { y: -20, duration: .5, ease: "power3.inOut", delay:1 });
     tl.to('.animating--title .inner', { y: -40, duration: .5, ease: "power3.inOut", delay:1 });
     tl.to('.animating--title .inner', { y: -60, duration: .5, ease: "power3.inOut", delay:1 });
     tl.to('.animating--title .inner', { y: -80, duration: .5, ease: "power3.inOut", delay:1 });

  }, [])
  return (
  <div className="small--caption ma uppercase max-200 size-medium text-center text-normal" {...props}>
    <div className='animating--title' >
      <div className='inner'>
        <span className='block'>{titles[0].caption}</span>
        <span className='block'>{titles[1].caption}</span>
        <span className='block'>{titles[2].caption}</span>
        <span className='block'>{titles[3].caption}</span>
        <span className='block'>{titles[0].caption}</span>
      </div>
    </div>
    <div className='caption hide'>
      {text}
    </div>
  </div>
  )
} 
export default AnimateCaption
